// Moves the swiper prev/next arrows into the heading/button column on
// .home-page-carousel-group sections, so they sit below the button instead
// of below the whole carousel. Pure CSS can't do this: the arrows live
// inside the carousel's own overflow:hidden box, so only a real DOM move
// (not a visual reposition) gets them out.
//
// Swiper only wires up click handlers on the next/prev buttons once it
// initializes, and it looks them up inside the .swiper container -- and
// this theme initializes each carousel lazily (only once it scrolls near
// the viewport), well after window 'load'. So the arrows must stay put
// until Swiper has actually initialized; moving them earlier leaves
// Swiper's navigation pointing at nothing, and the buttons go dead while
// dragging still works.
window.addEventListener('load', () => {
  document.querySelectorAll('.home-page-carousel-group').forEach((group) => {
    const row = group.querySelector(':scope > .group-block-content');
    const arrows = group.querySelector('.swiper-btns-wrap');
    const swiperEl = group.querySelector('.swiper');
    if (!row || !arrows || !row.firstElementChild) return;

    const moveArrows = () => row.firstElementChild.appendChild(arrows);

    if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) {
      moveArrows();
      return;
    }

    const observer = new MutationObserver(() => {
      if (swiperEl.classList.contains('swiper-initialized')) {
        observer.disconnect();
        moveArrows();
      }
    });
    observer.observe(swiperEl, { attributes: true, attributeFilter: ['class'] });
  });
});
